import { ObserveVisibility } from 'vue-observe-visibility'

export default function registerOtherDirectives(app) {
  app.directive('observe-visibility', ObserveVisibility)
}
